<template>
  <div id="main-container">
    <PageTitle id="page-title" />
    <div id="cols">
      <div id="form-col">
        <ClearVideo class="section" />
        <CreatorGallery class="section" />
      </div>
      <MusicDownloads class="section" />
    </div>
    <FaqSection class="section" id="faq-section"></FaqSection>
  </div>
</template>

<script>
import CreatorGallery from "./components/CreatorGallery.vue";
import ClearVideo from "./components/ClearVideo.vue";
import MusicDownloads from "./components/MusicDownloads.vue";
import PageTitle from "./components/PageTitle.vue";
import FaqSection from "./components/FaqSection.vue";

export default {
  name: "App",

  components: {
    ClearVideo,
    MusicDownloads,
    CreatorGallery,
    PageTitle,
    FaqSection,
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}

h1 {
  margin-top: 0px;
  font-weight: 600;
  letter-spacing: -0.01em;
  text-align: center;
}

@media screen and (min-width: 1210px) {
  h1 {
    text-align: left;
  }
}

h3 {
  font-weight: 600;
}

p {
  line-height: 1.6;
}

a {
  transition: color 0.2s ease;
}

#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #3f3a35;
  padding: 1.5em;
  max-width: 1400px;
  margin: 0 auto;
}

#page-title {
  text-align: center;
}

.section {
  background-color: #fcefd6;
  padding: 28px 32px;
  border-radius: 16px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s ease;
}

.section:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

#cols {
  margin-top: 50px;
  justify-content: center;
}

#faq-section {
  margin-left: auto;
  margin-right: auto;
}

#site-footer {
  text-align: center;
  padding: 32px 16px 24px;
  font-size: 0.85em;
  color: #8a7e72;
}

@media screen and (min-width: 1210px) {
  #form-col {
    min-width: 370px;
    max-width: 500px;
  }
  #app {
    padding: 2em 3em;
  }

  #cols {
    display: flex;
    flex-flow: row;
    gap: 10px 50px;
  }
}
</style>
